import { render, staticRenderFns } from "./BizChainIcon.vue?vue&type=template&id=4e4387c9&scoped=true&"
import script from "./BizChainIcon.vue?vue&type=script&lang=js&"
export * from "./BizChainIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4387c9",
  null
  
)

export default component.exports